import { getRequest } from '../services/requestHandler';
import { Digit } from '../models';

//5537, 3 for testing
export const getDigit = async () => {
  const url = `digit`;
  const response = await getRequest<Digit>('Digit', url);
  return response;
};
